module.exports = __webpack_public_path__ + "fonts/ff1e90c.ttf";